import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-with-text.component.scss';
var ImageWithText = /** @class */ (function (_super) {
    tslib_1.__extends(ImageWithText, _super);
    function ImageWithText(element) {
        return _super.call(this, element) || this;
    }
    ImageWithText.prototype.init = function () {
    };
    ImageWithText.prototype.bindEvents = function () {
    };
    return ImageWithText;
}(Base));
export { ImageWithText };



//////////////////
// WEBPACK FOOTER
// ./components/image-with-text/image-with-text.component.ts
// module id = 379
// module chunks = 0